import * as React from 'react';

interface IHealthcare {
  isHealthcare: boolean;
  shouldDisplayNotice: boolean;
}

interface IHealthcareAction {
  setIsHealthcare: (isHealthcare: boolean) => void;
  setShouldDisplayNotice: (setShouldDisplayNotice: boolean) => void;
}

export const HealthcareContext = React.createContext<IHealthcare>({
  isHealthcare: false,
  shouldDisplayNotice: false,
});

export const HealthcareActionContext = React.createContext<IHealthcareAction>({
  setIsHealthcare: (isHealthcare: boolean) => {
    return isHealthcare;
  },
  setShouldDisplayNotice: (shouldDisplayNotice: boolean) => {
    return shouldDisplayNotice;
  },
});

const HealtcareContextProvider = (props) => {
  const [isHealthcare, setIsHealthcare] = React.useState<boolean>(false);
  const [shouldDisplayNotice, setShouldDisplayNotice] = React.useState<boolean>(false);

  return (
    <HealthcareContext.Provider value={{ isHealthcare, shouldDisplayNotice }}>
      <HealthcareActionContext.Provider value={{ setIsHealthcare, setShouldDisplayNotice }}>{props.children}</HealthcareActionContext.Provider>
    </HealthcareContext.Provider>
  );
};

export default HealtcareContextProvider;
